import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  close: <PortalMessage id='t.app.close' defaultMessage='Chiudi' />,
  tabData1: <PortalMessage id='t.app.results.details.tabData1' defaultMessage='Periodo 1' />,
  tabData2: <PortalMessage id='t.app.results.details.tabData2' defaultMessage='Periodo 2' />,
  period: <PortalMessage id='t.app.results.details.period' defaultMessage='Periodo di riferimento:' />,
  transactions: <PortalMessage id='t.app.results.details.transactions' defaultMessage='Transazioni' />,
  transacted: <PortalMessage id='t.app.results.details.transacted' defaultMessage='Transato' />,
  payment: <PortalMessage id='t.app.results.details.payment' defaultMessage='Pagamento' />,
  titleNavigation: <PortalMessage id='t.app.results.details.payments.titleNavigation' defaultMessage='Dettaglio metodi di pagamento' />,
  paymentsMethods: <PortalMessage id='t.app.results.details.payments.paymentsMethods' defaultMessage='Metodi di pagamento' />,
  averageAmount: <PortalMessage id='t.app.results.details.payments.averageAmount' defaultMessage='Importo medio' />,
  title: <PortalMessage id='t.app.results.details.payments.title' defaultMessage='Transazioni per metodo di pagamento' />
}

export default formattedMessage
